module.exports = __webpack_public_path__ + "img/dianchi.6f129c26.png";